import githubIcon from 'assets/images/contacts/github.svg';
import envelopeIcon from 'assets/images/contacts/envelope.svg';
import telegramIcon from 'assets/images/contacts/telegram.svg';

const contacts = [
  {
    iconText: 'Мой Email',
    iconPath: envelopeIcon,
    link: 'mailto:notacat.mail@gmail.com',
  },
  {
    iconText: 'Мой GitHub',
    iconPath: githubIcon,
    link: 'https://github.com/NotACat1',
  },
  {
    iconText: 'Мой Telegram',
    iconPath: telegramIcon,
    link: 'https://t.me/NotACat2',
  },
];

export { contacts };
